var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopDirection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 17.167a.917.917 0 00-.917.917v3.666h1.833V19h2.75v2.292l3.208-3.208-3.208-3.209v2.292h-3.667zm3.397-7.89l9.075 9.075a.917.917 0 010 1.296l-9.075 9.075a.916.916 0 01-1.296 0l-9.075-9.075a.917.917 0 010-1.296l9.075-9.075a.917.917 0 011.296 0z",
    fill: "#585858"
  })));
}
export default __webpack_public_path__ + "static/media/shop-direction.082b6ce3.svg";
export { SvgShopDirection as ReactComponent };